<div class="loading-indicator k-i-loading position-absolute" 
    *ngIf="loading$ | async">
</div>